export enum ContactTypeEnum {
    Mobile = "Mobile",
    Email = "Email",
    Phone = "Phone"
}